export default "__VITE_ASSET__cb7017bb__"